var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.JobType != 'RVP') ? _c('div', {
    attrs: {
      "id": "trackPaginate"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingAllocationShipmentListLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingAllocationShipmentListLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered pending-for-delivery-ShipmentList"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.PendingForAllocationShipmentList.length > 0) ? _vm._l((_vm.PendingForAllocationShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.pendingdays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.handoverdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipaddress))])])
  }) : [_vm._m(1)]], 2)]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _c('div', {
    attrs: {
      "id": "trackPaginate"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingAllocationShipmentListLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingAllocationShipmentListLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered pending-for-delivery-ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllShipments($event)
      },
      "change": function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Handover Date")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")])])]), _vm._v(" "), _c('tbody', [(_vm.PendingForAllocationShipmentList.length > 0) ? _vm._l((_vm.PendingForAllocationShipmentList), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReverseShipmentData),
        expression: "selectedReverseShipmentData"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": "selectedPickups"
      },
      domProps: {
        "value": row.shippingid,
        "checked": Array.isArray(_vm.selectedReverseShipmentData) ? _vm._i(_vm.selectedReverseShipmentData, row.shippingid) > -1 : (_vm.selectedReverseShipmentData)
      },
      on: {
        "click": function($event) {
          return _vm.PassSelectedData()
        },
        "change": function($event) {
          var $$a = _vm.selectedReverseShipmentData,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.shippingid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedReverseShipmentData = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedReverseShipmentData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedReverseShipmentData = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.pendingdays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.handoverdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipaddress))])])
  }) : [_vm._m(2)]], 2)]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Handover Date")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e82cfd78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/pendingForAllocationShipments.vue
// module id = 1128
// module chunks = 1